import React from "react";
import ImgAbout from "../static/img/heart.png";
import "./footer.css";
 
 import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Modal
} from "reactstrap";

export default class Footer extends React.Component {
  render() {
    return (
      <div className="container-fluid remove-padding bg-footer fixed ">
         <div className="container footer p-2 flex-column-reverse flex-lg-row">


<span> TAKWA CH ©  </span>

          <div className="footer-div">
 
            <p className="footer-text">{("Made with ❤️ in Jun 2020 ")}</p>
          </div>
          <div className="footer-navigation mb-3 mb-lg-0 flex-column flex-sm-row">

          <NavLink
                  className="menu-item rounded-link"
                  href="/"    >
 top page</NavLink>  

          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer.js